import axios from "axios";
import { API_URL } from "../utils/config";

let getAuthToken = () => null;
//let getImpersonatedUser = () => null;

export function setTokenUtils({tokenGetter/*, impersonatedUserGetter*/}) {
  getAuthToken = tokenGetter;
  //getImpersonatedUser = impersonatedUserGetter;
}

const httpClient = axios.create({
  baseURL: `${API_URL}`,
  headers: {
    "Content-Type": "application/json",
  },
});

httpClient.interceptors.request.use(
  (config) => {
    const token = getAuthToken?.();
    //const impersonatedUser = getImpersonatedUser?.();
    if(token) {
      config.headers.Authorization = token;
      config.headers["Content-Type"] = "application/json";
    }

    config.headers["Cache-Control"] = "no-cache, no-store, must-revalidate";

    const [baseUrl, queryString] = config.url.split('?');
    const searchParams = new URLSearchParams(queryString || '');
    // if(impersonatedUser != undefined) {

    //   searchParams.set('impersonatedUser', impersonatedUser);
    // }
    config.url = `${baseUrl}`;
    if(searchParams.size != 0) {
      config.url += `?${searchParams.toString()}&t=${Date.now()}`;
    } else {
      config.url += `?t=${Date.now()}`
    }
  
    return config;
  },
  (error) => Promise.reject(error)
);

httpClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {

    if(error.response?.status === 401){
      window.dispatchEvent(new CustomEvent('authExpired'));
    }
    return Promise.reject(error);
  }
);

export default httpClient;
